import React from "react";
import { compose, withAppContext, withActions } from "containers/HOC";
import { Form, Field } from "react-final-form";
import * as FormUtils from "common/FormUtils";
import Modal from "components/new/Modal";
import ModalBody from "components/new/ModalBody";
import ModalFooter from "components/new/ModalFooter";
import Grid from "components/Grid";
import GridCell from "components/GridCell";
import TextField from "components/FormFields/TextField";
import { changePassword } from "containers/Auth/_actions";

const ChangePasswordModal = ({ online, viewModel, changePassword }) => {
    const validate = (values) => {
        const validation = {};

        validation.currentPassword = FormUtils.validators.required(values.currentPassword);
        validation.currentPassword = validation.currentPassword || FormUtils.validators.minLength(8)(values.currentPassword);
        validation.currentPassword = validation.currentPassword || FormUtils.validators.maxLength(50)(values.currentPassword);

        validation.newPassword = FormUtils.validators.required(values.newPassword);
        validation.newPassword = validation.newPassword || FormUtils.validators.minLength(8)(values.newPassword);
        validation.newPassword = validation.newPassword || FormUtils.validators.maxLength(50)(values.newPassword);

        validation.confirmNewPassword = FormUtils.validators.required(values.confirmNewPassword);
        if (values.confirmNewPassword !== values.newPassword) validation.confirmNewPassword = validation.confirmNewPassword || "Password does not match";

        return validation;
    };

    const submit = (values) => {
        changePassword(values.currentPassword, values.newPassword);
    };

    return (
        <Form initialValues={viewModel} validate={validate} onSubmit={submit}>
            {({ handleSubmit, submitting }) => {
                const disableSave = !online || submitting;
                return (
                    <Modal title="Change password" skinny>
                        {({ closeModal }) => (
                            <form onSubmit={handleSubmit}>
                                <ModalBody>
                                    <Grid>
                                        <GridCell className="">
                                            <Field name="currentPassword" label="Current password" placeholder="Enter your current password" required type="password" component={TextField} />
                                            <Field name="newPassword" label="New password" placeholder="Enter your new password" required type="password" component={TextField} />
                                            <Field name="confirmNewPassword" label="Confirm new password" placeholder="Confirm your new password" required type="password" component={TextField} />
                                        </GridCell>
                                    </Grid>
                                </ModalBody>
                                <ModalFooter>
                                    <div className="ButtonBar">
                                        <div className="ButtonBar-left">
                                            <button id="cancel-button" type="button" className="Button Button--secondary" onClick={closeModal}>
                                                Cancel
                                            </button>
                                        </div>
                                        <div className="ButtonBar-right">
                                            <button id="save-button" type="submit" className="Button Button--primary" disabled={disableSave}>
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </ModalFooter>
                            </form>
                        )}
                    </Modal>
                );
            }}
        </Form>
    );
};

export default compose(withAppContext, withActions({ changePassword }))(ChangePasswordModal);
